import { render, staticRenderFns } from "./DistributeBalanceUnallocatedModal.vue?vue&type=template&id=2493dbbb&scoped=true&"
import script from "./DistributeBalanceUnallocatedModal.vue?vue&type=script&lang=ts&"
export * from "./DistributeBalanceUnallocatedModal.vue?vue&type=script&lang=ts&"
import style0 from "./DistributeBalanceUnallocatedModal.vue?vue&type=style&index=0&id=2493dbbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493dbbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VDialog,VDivider,VIcon,VImg,VRow,VTextField})
